module.exports = __webpack_public_path__ + "static/thumbnail-1c6db7f9fc3b691d81a8be0a9419c7b9.png";